<template>
  <el-table-column
    prop="mobile"
    sortable
    label="Mobil"
    show-overflow-tooltip
  >
    <template slot-scope="scope">
      {{ scope.row.mobile | phone }}
    </template>
  </el-table-column>
</template>

<script>
  export default {
    propName: 'mobile',
  };
</script>
